// extracted by mini-css-extract-plugin
export var subtitle = "_aw-2";
export var title = "_aw-0";
export var titleNoWrap = "_aw-1";